import { render } from "./Eleicoes2018.vue?vue&type=template&id=7c9b6897&scoped=true"
import script from "./Eleicoes2018.vue?vue&type=script&lang=js"
export * from "./Eleicoes2018.vue?vue&type=script&lang=js"

import "./Eleicoes2018.vue?vue&type=style&index=0&id=7c9b6897&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9b6897"]])

export default __exports__